export default function splitClinvarMainData(mainData, reviewStars, db) {
  if (!mainData || db.name !== "ClinVar") {
    return { mainData, reviewStars };
  }
  const re = new RegExp(/\*\*\d\*\*$/g);
  const match = mainData.match(re);
  if (match) {
    const stars = match[0].split("**")[1];
    const cleanMainData = mainData.replace(match[0], "");
    const extracted = parseInt(stars, 10);
    return { mainData: cleanMainData, reviewStars: extracted };
  }
  return { mainData, reviewStars };
}
